import { ReviewWritableResponseV2 } from '~/__generated__/__types__'
import { DateTime } from 'luxon'
import { ReviewApiServiceUnavailableReason } from '~/api/services/review-api/index.type'
import { OrderButton, OrderButtonType } from '~/app/components/order-converter/types'

const getLeftDaysText = (reviewAvailableUntil: string | undefined, currentAt: string) => {
  if (!reviewAvailableUntil) {
    return null
  }

  const leftDays = Math.floor(
    DateTime.fromFormat(reviewAvailableUntil, 'yyyy-MM-dd')
      // parameter 로 전달된 날짜를 inclusive 하게 처리한다
      .endOf('day')
      .diff(DateTime.fromISO(currentAt), ['days']).days
  )

  const PREFIX = '후기 작성하러 가기'

  if (leftDays < 1) {
    return `${PREFIX} (오늘 자정까지)`
  }
  return `${PREFIX} (${leftDays}일 남음)`
}

const getReviewWritableButton = (
  reviewWritable: ReviewWritableResponseV2,
  currentAt: string
): OrderButton | undefined => {
  const { available, reviewAvailableUntil, unavailableReason, orderId } = reviewWritable
  const leftDaysText = getLeftDaysText(reviewAvailableUntil, currentAt)

  if (available && leftDaysText) {
    return {
      type: OrderButtonType.BASIC,
      title: leftDaysText,
      id: 'review',
      data: { id: orderId },
      isDisabled: false,
    }
  } else {
    const expiredMessage =
      unavailableReason === ReviewApiServiceUnavailableReason.ELAPSED
        ? '후기 작성 기간 만료'
        : unavailableReason === ReviewApiServiceUnavailableReason.ALREADY_WRITTEN
          ? '후기 작성 완료'
          : null
    if (expiredMessage) {
      return {
        type: OrderButtonType.BASIC,
        title: expiredMessage,
        id: 'review',
        isDisabled: true,
      }
    }
  }
}

export default getReviewWritableButton
